// api链接静态资源
import gpOrder from './gporder-api'
import gpGateway from './gp-gateway'
import gpTaskWorker from './gp-task-worker'
import gpUser from './gp-user'
import gpStock from './gp-stock'
import gpChat from './gp-chat'
import jindashiApi from './jindashi-api'
const GP_LIVE = process.env.ENV !== 'preview' ? '/api/gp-live' : '/api/gp-live-staging'

export default {
  ...gpOrder,
  ...gpGateway,
  ...gpTaskWorker,
  ...gpUser,
  ...gpStock,
  ...gpChat,
  ...jindashiApi,
  /*
  * 专辑详情
  * */
  getAlbumDetail: 'get /coop/album/:id',
  /*
  * 专辑列表
  * body
  *   limit
  *   page
  * */
  getAlbums: 'get /coop/album',
  /*
  * 用户已购
  * body
  *   page
  *   limit
  * */
  getUserAlbums: 'get /coop/user/album',
  /*
  * 用户订单
  * body
  *   page
  *   limit
  * */
  getUserOrders: 'get /coop/user/order',
  /*
  * 用户订单详情
  * */
  getUserOrderDetail: 'get /coop/user/order/:orderId',
  /*
  * 获取手机验证码
  * body
  *   phone
  * */
  getVerifyCode: 'post /public/sendSms',
  /*
  * 绑定手机
  * body
  *   phone: string
  *   verifyCode: string
  * */
  bindMobilephone: 'put /user/phone',

  bindMobilephone2: 'put /user/phone/bind',

  /*
  * 手机号加密信息
  * */
  phoneEncryption: 'get /coop/user/phone',
  /*
  * 手机号-验证码登录
  * phone: type: "string"
  * verifyCode: type: "string"
  * */
  phoneLogin: 'post /public/v1/sms/login',
  /**
   * 账号密码登录
   * phone, password
   */
  accountLogin: 'post /public/v2/account/login',
  /*
  * 获取图形验证码
  * */
  captcha: 'post /public/captcha',
  // 图形验证码 获取验证码
  getVerifyCode2: 'post /public/sms/verifyCode',
  // 获取该手机号是否为注册用户
  getPhoneUser: 'get /user/check/byPhone',
  /*
  * 字符串换取二维码
  * body
  *   message
  * */
  qrcode: 'post /tool/qrcode',

  // 评论详情
  getComment: 'get /comments/:id',

  authorId: 'get /author/pure/:userId',
  getLiveLobby: 'get /v5/room/recommend',
  // 观点详情
  viewDetail: 'get /viewPoint/:id',
  // 观点评论 id, page, limit
  viewComment: 'get /viewPoint/commentList',
  // 研报
  stockReport: 'get /stockReport/:id',
  // 券商列表
  getTraderList: 'get /operation/accountBroker/:type',
  // 视频/文章 分享配置
  getShareConfig: 'get /share/webConfig/:targetType/:targetId',
  // h5直播分享弹窗配置
  getDownloadConfig: 'get /room/:roomId/downloadConfig',
  // 获取定向直播
  getSpecialPaidLive: 'get /coop/zsld/sendPaidLive',
  // 获取指定付费专栏
  getSpecialPaidAlbum: 'get /coop/zsld/album',
  // 发送直播评论
  sendLiveComment: 'post /v2/room/:roomId/comments',
  // 芝士律动通过token登录
  zsldLogin: 'post /coop/zsld/login',

  liveBallConfig: `get ${GP_LIVE}/api/live/room/queryH5FloatingBall`,
  // 查询专辑下载配置
  // "targetType":1:专辑2:新华网专辑
  getAlbumDownloadConfig: 'get /h5DownloadPrompt',
  // 通过ID获取用户信息
  getUser: 'get /users/:userId',
  // 查询播主 1、是否允许进入页面加入群组 2、绑定手机号成功后加入群组
  findGroupIdsByAuthorUid: 'get /authorPromotion/findGroupIdsByAuthorUid',
  // 加入群聊（股拍群聊）
  joinGroupChat: 'post /groupChat/:id/join'
}



// WEBPACK FOOTER //
// ./src/apis/api-urls/constants.js